/* badge-new.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./badge-new.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { memo } from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { formatValue } from './internal/utils';

/**
 * New appearance types for visual refresh.
 */

/**
 * Props for BadgeNew component with new appearance names.
 */

/**
 * Mapping from old appearance names to new appearance names for visual refresh.
 * Used when Badge component passes old prop names to BadgeNew.
 */
export var appearanceMapping = {
  added: 'success',
  removed: 'danger',
  default: 'neutral',
  primary: 'information',
  primaryInverted: 'inverse',
  important: 'danger'
};

/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */
// Nested selectors with data attributes are required for theme switching
var stylesNew = {
  root: "_2rkolb4i _18zr1b66 _1rjcidpf _1e0c116y _vchhusvi _1ul91ejb _1bah1h6o _1o9zidpf _1kz6184x",
  success: "_syaz1p1e _bfhk1s9h _1ut5iv2r _y8hm1hpu",
  danger: "_syaz1blx _bfhkrkii _1ut5zp7h _y8hm84f9",
  warning: "_bfhk1kmu _syazmgs1 _pers14ug _y8hmdo2b",
  information: "_syaz1qd9 _bfhk1dq8 _1ut5e5eq _y8hmxr8b",
  discovery: "_syaz1g72 _bfhkiizu _1ut51bbx _y8hm17oz",
  neutral: "_syazi7uo _bfhk7i23 _1ut5z5kg _y8hm1g0e",
  inverse: "_bfhkvuon _syazi7uo"
};
/* eslint-enable @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors */

var badgeValueWithNegativeNumberSupported = function badgeValueWithNegativeNumberSupported(children, max) {
  return typeof children === 'number' && max ? formatValue(children, max) : children;
};

/**
 * __BadgeNew__
 *
 * New visual refresh implementation of Badge component for the labelling system.
 * This component is used when the 'platform-dst-lozenge-tag-badge-visual-uplifts' feature flag is enabled.
 *
 * Uses new appearance naming convention:
 * - success (green)
 * - danger (red)
 * - neutral (gray)
 * - information (blue)
 * - inverse (inverted colors)
 * - warning (orange/yellow)
 * - discovery (purple)
 */
var BadgeNew = /*#__PURE__*/memo(function BadgeNew(_ref) {
  var _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? 'neutral' : _ref$appearance,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? 0 : _ref$children,
    _ref$max = _ref.max,
    max = _ref$max === void 0 ? 99 : _ref$max,
    style = _ref.style,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("span", {
    "data-testid": testId,
    style: {
      background: style === null || style === void 0 ? void 0 : style.backgroundColor,
      color: style === null || style === void 0 ? void 0 : style.color
    },
    className: ax([stylesNew.root, stylesNew[appearance]])
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    align: "center",
    color: "inherit"
  }, badgeValueWithNegativeNumberSupported(children, max)));
});
export default BadgeNew;